import React from "react";
import { CloseButton } from "./buttons/closeButton";

export interface ModalProps {
  icon?: React.ReactNode;
  header?: string;
  message?: React.ReactNode;
  children?: React.ReactNode;
  onClose?: () => void;
}

const Modal: React.FC<ModalProps> = ({ icon, header = "Notification", message, children, onClose }) => {
  return (
    <>
      <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-40" onClick={onClose} />
      <div
        className="fixed inset-0 z-50 flex items-center justify-center p-4"
        onClick={onClose ? () => onClose() : undefined}
      >
        <div
          className="relative bg-white rounded-xl shadow-xl border border-secondary-200 max-w-md w-full p-6 z-50"
          role="dialog"
          aria-modal="true"
          onClick={(e) => e.stopPropagation()}
        >
          {onClose && <CloseButton handleClose={onClose} />}
          <div className="flex items-start gap-4 mb-4">
            {icon && <div className="flex-shrink-0">{icon}</div>}
            <h2 className="text-xl font-semibold text-secondary-900">{header}</h2>
          </div>
          <div className="text-secondary-700">
            {message}
            {children && <div className="mt-4">{children}</div>}
          </div>
        </div>
      </div>
    </>
  );
};

export { Modal };
